import Panel from './Panel.vue'
import Panels from './Panels.vue'

export { Panel, Panels }